import { stages } from "./enums/room-stages";

const getters = {
  room: (state) => state.room,
  token: (state) => state.token,
  
  isToCallStage: (state) => state.stage === stages.TO_CALL,
  isCalledStage: (state) => state.stage === stages.CALLED,
  isSuccessStage: (state) => state.stage === stages.SUCCESS,
  isErrorStage: (state) => state.stage === stages.ERROR,
  isInterventionConfirmedStage: (state) => state.stage === stages.INTERVENTION_CONFIRMED,
  
  error: (state) => state.error,
  isLoading: (state) => state.status === 'loading',
};

export { getters }